<template>
  <div>
    <ul class="boxShadow">
      <li v-for="(item, index) in hotSearchList" :key="index" class="clearfix">
        <img :src="item.userIcon" alt="">
        <div>
          <h4 class="textOver" @click="goPostContent(item.id)">{{ item.subject }}</h4>
          <p>{{ item.views }}人浏览</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    hotSearchList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    goPostContent(id) {
      this.$router.push({ path: `/navigator/bbs/postContent/${id}` });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';

li {
  height: 32px;
  padding: 12px 20px;
  border-bottom: 2px solid #f6f6f6;
  background-color: #fff;
  img {
    float: left;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 10px;
  }
  >div {
    float: left;
  }
  h4 {
    cursor: pointer;
    width: 290px;
  }
  p {
    color: $color-main;
    font-size: 12px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/navigator/bbs/microCommunity/HotSearchList.vue